import { useColorMode } from '@chakra-ui/react';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export default function WelcomePage() {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  const location = useLocation();
  const stateProps = location.state;

  setTimeout(() => {
    navigate(stateProps?.redirectUrl || '/home', { replace: true });
  }, 2000);

  return (
    <div
      className="flex flex-col items-center justify-center h-screen"
      style={{
        backgroundImage: `url('/assets/backgrounds/welcome_background_${colorMode}.png')`,
        backgroundRepeat: 'round'
      }}
    >
      <div className="h-[96px] w-[96px] mb-[16px]">
        <img src={'../assets/onboarding/PartyPopper.png'} alt="welcome" />
      </div>
      <div className="flex items-center justify-center min-w-[100%]">
        <div className="flex flex-col items-center justify-center">
          <span className="text-main-light-1 dark:text-main-dark-1 text-[26px] font-bold mb-[14px]">
            {stateProps?.title || t('newWelcomePage.title')}
          </span>
          <span className="text-main-light-4 dark:text-main-dark-4 text-[16px] font-medium">
            {stateProps?.description || t('newWelcomePage.description')}
          </span>
        </div>
      </div>
    </div>
  );
}
